import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// import App from './App v1.js';
// import App from './App v2.js';
import App from './App v3.js';
// import App from './App v4.js';

const root = ReactDOM.createRoot(document.querySelector(`#root`));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
